// Wrapper for window.sessionStorage. Falls back on inMemoryStorage if
// browser doesn't support sessionStorage.
import StorageService from './storage.service'

class SessionStorageService extends StorageService {
  // Specify which type of browser storage we want.
  constructor() {
    super('sessionStorage')
  }
}

export let sessionStorageService = new SessionStorageService()
